/**
 * @generated SignedSource<<c31a5b33bce49b71b23fc5e7a36aaebc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type BrandTheme = "ROOTLY" | "ROOTLY_COBRAND" | "ROOTLY_HYBRID" | "TIERZERO" | "%future added value";
export type IntegrationType = "AWS" | "BITBUCKET" | "BUILDKITE" | "CAPABILITIES" | "CLOUDWATCH" | "CONFLUENCE" | "CURSOR" | "DATADOG" | "DEVIN" | "DISCORD" | "ELASTICSEARCH" | "FIREHYDRANT" | "GCP" | "GCP_CLOUD_MONITORING" | "GITHUB" | "GITLAB" | "GRAFANA_CLOUD" | "INCIDENT_IO" | "JIRA" | "LANGFUSE" | "LANGSMITH" | "LINEAR" | "NEW_RELIC" | "NOTION" | "OPENSEARCH" | "OPSGENIE" | "PAGERDUTY" | "PGANALYZE" | "POSTGRESQL" | "PROMETHEUS" | "ROLLBAR" | "ROOTLY" | "SENTRY" | "SLACK" | "SNOWFLAKE" | "SOCKET" | "TEMPORAL" | "%future added value";
export type OnboardingInitializationStatus = "COMPLETED" | "FAILED" | "IN_PROGRESS" | "NOT_STARTED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type OnboardingContent_organization$data = {
  readonly activeCustomMcpServers: ReadonlyArray<{
    readonly name: string;
  }>;
  readonly brandTheme: BrandTheme;
  readonly id: any;
  readonly integrations: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: any;
        readonly integrationType: IntegrationType;
      };
    }>;
  };
  readonly isCodeAccessOptional: boolean;
  readonly latestInstruction: {
    readonly body: string;
    readonly id: any;
  } | null | undefined;
  readonly onboardingCompletedAt: any | null | undefined;
  readonly onboardingInitializationStatus: OnboardingInitializationStatus;
  readonly teams: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: any;
        readonly name: string;
      };
    }>;
  };
  readonly " $fragmentType": "OnboardingContent_organization";
};
export type OnboardingContent_organization$key = {
  readonly " $data"?: OnboardingContent_organization$data;
  readonly " $fragmentSpreads": FragmentRefs<"OnboardingContent_organization">;
};

import OnboardingContentRefetchQuery_graphql from './OnboardingContentRefetchQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": OnboardingContentRefetchQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "OnboardingContent_organization",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "brandTheme",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isCodeAccessOptional",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "onboardingCompletedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "onboardingInitializationStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLTeamConnection",
      "kind": "LinkedField",
      "name": "teams",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLTeamEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "GraphQLTeam",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLIntegrationConnection",
      "kind": "LinkedField",
      "name": "integrations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLIntegrationEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "GraphQLIntegration",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "integrationType",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLInstruction",
      "kind": "LinkedField",
      "name": "latestInstruction",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "body",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLCustomMcpServer",
      "kind": "LinkedField",
      "name": "activeCustomMcpServers",
      "plural": true,
      "selections": [
        (v1/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "GraphQLOrganization",
  "abstractKey": null
};
})();

(node as any).hash = "db1132edf118073b003ed9387fce6841";

export default node;
